const CIRCLE_RADIUS = 37.5;
const ICON_SIZE = 50;
const TEXT_WIDTH = 150;
const TEXT_HEIGHT = 200;

export const RoundIconScatter = (props) => {
  const {
    cx,
    cy,
    yAxis,
    node,
    text,
    iconColor,
    lineStrokeColor,
    circleFillColor,
    circleStrokeColor,
    strokeDash,
  } = props;

  return (
    <svg>
      <line
        x1={cx}
        y1={yAxis.height + yAxis.y}
        x2={cx}
        y2={cy + CIRCLE_RADIUS}
        stroke={lineStrokeColor}
        strokeDasharray={strokeDash}
      />
      <circle
        cx={cx}
        cy={cy}
        r={CIRCLE_RADIUS}
        fill={circleFillColor}
        stroke={circleStrokeColor}
        strokeDasharray={strokeDash}
      />
      <props.icon
        x={cx - ICON_SIZE / 2}
        y={cy - ICON_SIZE / 2}
        width={ICON_SIZE}
        height={ICON_SIZE}
        color={iconColor}
      />
      <foreignObject
        x={cx - TEXT_WIDTH / 2}
        y={cy - TEXT_HEIGHT / 2 - 10}
        width={TEXT_WIDTH}
        height={TEXT_HEIGHT}
      >
        <p style={{ textAlign: "center" }}>{text}</p>
      </foreignObject>
      <text x={cx} y={cy - 50} textAnchor="middle">
        {new Date(node.x).toLocaleString("en", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })}
      </text>
    </svg>
  );
};
